import styled from 'styled-components';

export const StyledMaintenanceWrapper = styled.div`
    .page-title {
        font-size: 30px;
        margin-bottom: 20px;

        .building-address {
            color: var(--bllink-purple);
        }
    }

    #inlineFrameExample {
        width: 100%;
        margin-top: 20px;
    }

    @media screen and (max-width: 768px) {
        margin: 0 -25px 20px;
    }
`